<template>
    <div>
        <el-dialog
            :visible.sync="dialogTableVisible"
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <div class="payModel">
                <h3>支付仍在后台处理中 请耐心等待</h3>
                <p class="payModel_text">若一直没有收到支付结构，您可以:</p>
                <div class="payModel_btn">
                    <el-button type="primary" @click="successDialog()">支付成功</el-button>
                    <el-button @click="closeDialog">支付失败</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogTableVisible: false,
            };
        },
        methods: {
            init() {
                this.dialogTableVisible = true;
            },
            successDialog() {
                this.$emit('refreshData');
                this.dialogTableVisible = false;

            },
            closeDialog() {
                this.$emit('refreshData');
                this.dialogTableVisible = false;
            }
        },
    };
</script>

<style lang="less" scoped>
    .payModel {
        text-align: center;

        h3 {
            font-size: 22px;
            margin-bottom: 10px;
        }

        .payModel_btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 40px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/payModelDialog.vue